import { FC } from 'react';

import SweetenerElementListing from 'components/main/SweetenerElement';

const SweetenerElement: FC = () => <SweetenerElementListing />;

export default SweetenerElement;
